/* eslint-env jquery */
const $ = jQuery;
const bodyFaq = $('body').hasClass('post-type-archive-faq');
const searchInput = $('#s');
const searchForm = $('#search-form');
const noFaqResult = $('#noFaqResult');
if (bodyFaq) {
  $(document).ready(faqInit);
}

function faqInit() {
  faqNav();
  faqSearchBar();
}

function faqNav() {
  const triggers = $('li.filter');
  const faqSections = $('.faqs-wrapper');
  for (const element of triggers) {
    element.addEventListener('click', () => {
      clearActive();
      element.classList.add('active');

      const { filter } = element.dataset;

      for (const faqSection of faqSections) {
        if (faqSection.classList.contains(filter)) {
          faqSection.classList.remove('hide');
        } else {
          faqSection.classList.add('hide');
        }
      }

      if (filter === 'all') {
        for (const faqSection of faqSections) {
          faqSection.classList.remove('hide');
        }
      }
    });
  }

  // set active class on faq menu
  const menu = $('#faqs');
  const links = menu[0].getElementsByClassName('nav-link');
  const hash = window.location.hash.slice(1);
  for (const link of links) {
    if (hash) {
      const curHash = link.hash.split('#')[1];
      const parent = link.parentNode;
      parent.classList.remove('active');
      if (curHash === hash) {
        const parent = link.parentNode;
        parent.classList.add('active');
      }
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();
      const current = menu.getElementsByClassName('active');
      if (current.length > 0) {
        current[0].classList.remove('active');
      }

      this.parentNode.classList.add('active');
      document.querySelector('.mobile-menu-trigger button span').textContent =
        document.querySelector('li.active a').textContent;
    });
  }
}

function clearActive() {
  const activeLink = document.querySelector('.active');
  // eslint-disable-next-line no-console
  console.log(activeLink);
  activeLink.classList.remove('active');
}

function faqSearchBar() {
  // set delay
  let typingTimer;
  const typeInterval = 500;

  // on search input keyup
  searchInput[0].addEventListener('keyup', (e) => {
    e.preventDefault();
    clearTimeout(typingTimer);
    typingTimer = setTimeout(liveFaqSearch, typeInterval);
  });

  // prevent default search form submit
  searchForm[0].addEventListener('submit', (e) => {
    e.preventDefault();
  });
}

function liveFaqSearch() {
  // locate the faq question elements
  const questions = $('.accordion-header');
  // locate the search input
  const searchQuery = searchInput[0].value;
  // get single faq holders, use spread operator to be able to use filter
  const faqSingle = [...document.querySelectorAll('.accordion-item')];
  // get faqs terms wrapper
  const faqsWrapper = $('.faqs-wrapper');
  // loop through the questions to handle results individually
  for (const question of questions) {
    // If the text is within the questions...
    if (
      question.textContent
        .toLowerCase()
        // ...and the text matches the search query...
        .includes(searchQuery.toLowerCase())
    ) {
      // ...remove the `.d-none` class.
      question.parentNode.classList.remove('d-none');
    } else {
      // otherwise, add the class.
      question.parentNode.classList.add('d-none');
    }
  }

  // handle no results found
  const result = faqSingle.filter((element) => !element.classList.contains('d-none'));
  if (!result.length && Array.isArray(result)) {
    // show no result text
    noFaqResult[0].classList.remove('d-none');
  } else {
    // hide no result text
    noFaqResult[0].classList.add('d-none');
  }

  // handle results for each taxonomy
  for (const element of faqsWrapper) {
    const temp = [...element.querySelectorAll('.accordion-item')];
    const res = temp.filter((element) => !element.classList.contains('d-none'));
    if (!res.length && Array.isArray(res)) {
      // show no result text
      element.classList.add('d-none');
    } else {
      // hide no result text
      element.classList.remove('d-none');
    }
  }
}

// eslint-disable-next-line no-undef
module.exports = { liveFaqSearch };
